import { useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Alert } from 'antd';
import { Spinner, PageHeader } from '@shared/ui';
import { useProfileQuery } from '@entities/manufacturer';
import { ProfileForm } from '@features/manufacturer-profile';

export function ProfilePage() {
  const { t } = useTranslation();
  const { data: profile, isLoading, isError, error, refetch } = useProfileQuery();
  const [params] = useSearchParams();
  const isOnboarding = params.get('kyc') === 'onboarding';

  if (isLoading) {
    return (
      <div className="flex h-full items-center justify-center">
        <Spinner />
      </div>
    );
  }
  if (isError || !profile) {
    return (
      <Alert
        type="error"
        showIcon
        message={t('profile.loadFail', { message: error?.message ?? 'unknown' })}
        action={
          <button
            type="button"
            className="ml-2"
            onClick={() => void refetch()}
          >
            {t('common.retry')}
          </button>
        }
      />
    );
  }

  return (
    <div className="flex flex-col gap-6">
      <PageHeader
        title={t('profile.title')}
        subtitle={isOnboarding ? t('profile.onboardingSubtitle') : t('profile.subtitle')}
      />
      <ProfileForm profile={profile} defaultTab={isOnboarding ? 'basic' : 'basic'} />
    </div>
  );
}
